export const SET_AVAIABLE_PRESS = "SET_AVAIABLE_PRESS";
